import React, { useState } from 'react'
import Backdrop from '@mui/material/Backdrop'
import { Box, Typography, Card, CardContent, Avatar, Chip, TablePagination, CircularProgress, Paper, IconButton, FormControl, InputLabel, Select, MenuItem, ToggleButton, ToggleButtonGroup, Tooltip, Alert, Modal, Fade } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { Link, useNavigate } from "react-router-dom";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import moment from 'moment';
import PhoneIcon from '@mui/icons-material/Phone'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from 'react';
import { sip, did, input, menu, global, short, shortFunctionList, employee, telecomunication } from "../../translate";
import Utils from "../../Utils";
import Cookies from "js-cookie";
import Api from "../../Api";
import { toast } from 'react-toastify';
import { activitiesStyles, employeeTableStyles, style } from "../../helpers/style";
import AssignedSearch from "./AssignedSearch";
import AltRouteIcon from '@mui/icons-material/AltRoute';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import VoicemailIcon from '@mui/icons-material/Voicemail';
import CallEndIcon from '@mui/icons-material/CallEnd';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import HistoryIcon from '@mui/icons-material/History';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useSelector } from 'react-redux';
const { REACT_APP_SERVER } = process.env;
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

export default function DidTable({
    data = [],
    setData = () => { },
    loading = false,
    title = '',
    viewMode = 'table',
    onViewModeChange = () => { }
}) {
    const langIndex = +localStorage.getItem('atsLang') || 1
    const [searchQuery, setSearchQuery] = useState('')
    const [providerFilter, setProviderFilter] = useState('all') // 'all' | 'telegram' | 'whatsapp'
    const navigate = useNavigate()
    const [sortBy, setSortBy] = useState(null)
    const [sortOrder, setSortOrder] = useState(null)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(Cookies.get("did") ? parseInt(Cookies.get("did")) : 10)
    const [copied, setCopied] = useState(false)
    const [shorts, setShorts] = useState([])
    const [employees, setEmployees] = useState([])
    const profile = useSelector(state => state.users.ursData)
    const employeeData = useSelector(state => state.users.employeeData)
    const profileEmpty = !profile || Object.keys(profile).length === 0
    const [managerModalOpen, setManagerModalOpen] = useState(false)

    const showManagerRequiredModal = () => setManagerModalOpen(true)

    const onEdit = (item) => {
        navigate(`/main_number/edit?phone=${item.pref}${item.did}&provider=${item.provider || ''}`)
    }

    const onDelete = async (item) => {
        if (profileEmpty) {
            showManagerRequiredModal()
            return
        }
        const deleteText = langIndex === 1 ? "Are you sure you want to delete?" :
            langIndex === 2 ? "Вы уверены, что хотите удалить?" :
                "Վստա՞հ եք, որ ցանկանում եք ջնջել"

        if (window.confirm(deleteText)) {
            try {
                const phoneNumber = `${item.pref}${item.did}`
                const response = await Api.deleteDid(phoneNumber, item.provider || '')
                if (response?.data?.status === 'ok') {
                    toast.success(global.deleted[langIndex])
                    setData(prev => prev.filter(n => !(n.pref === item.pref && n.did === item.did && n.provider === item.provider)))
                }
            } catch (error) {
                console.error('Error deleting main number:', error)
                toast.error('Error deleting main number')
            }
        }
    }

    const onAdd = () => {
        navigate('/main_number/add')
    }

    const titleArr = [
        sip.phone[langIndex],
        sip.forward[langIndex],
        sip.note[langIndex],
        did.active[langIndex],
        did.date[langIndex],
        did.line[langIndex],
        did.no_line[langIndex],
    ]

    let descArr = []

    const handleSearchChange = (value) => {
        setSearchQuery(value)
    }

    const handleProviderFilterChange = (_, value) => {
        if (value != null) {
            setProviderFilter(value)
            setPage(0)
        }
    }

    const handleSort = (column) => {
        if (sortBy === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
        } else {
            setSortBy(column)
            setSortOrder('asc')
        }
    }

    // Filter by provider: telegram = 3 or 4, whatsapp = 7
    const providerFilteredData = providerFilter === 'telegram'
        ? data.filter(item => item.provider === 3 || item.provider === 4)
        : providerFilter === 'whatsapp'
            ? data.filter(item => item.provider === 7)
            : data

    // Filter data based on search query
    const filteredData = searchQuery
        ? providerFilteredData.filter(item => {
            const query = searchQuery.toLowerCase()
            const phone = `${item.pref || ''}${item.did || ''}`
            const searchableFields = [
                phone,
                item.notes,
                item.output?.output || item.redirect_output,
                item.dlines,
                item.nodline,
            ]
            return searchableFields.some(field =>
                field !== null &&
                field !== undefined &&
                String(field).toLowerCase().includes(query)
            )
        })
        : providerFilteredData

    // Sort filtered data
    const sortedData = [...filteredData].sort((a, b) => {
        if (!sortBy) return 0

        let aValue, bValue

        switch (sortBy) {
            case 'phone':
                aValue = `${a.pref || ''}${a.did || ''}`
                bValue = `${b.pref || ''}${b.did || ''}`
                break
            case 'notes':
                aValue = a.notes || ''
                bValue = b.notes || ''
                break
            case 'forward':
                aValue = a.output?.output || a.redirect_output || ''
                bValue = b.output?.output || b.redirect_output || ''
                break
            case 'active':
                aValue = `${a.in || 0} - ${a.out || 0}`
                bValue = `${b.in || 0} - ${b.out || 0}`
                break
            case 'inTimeT':
                aValue = a.inTimeT || 0
                bValue = b.inTimeT || 0
                break
            case 'outTimeT':
                aValue = a.outTimeT || 0
                bValue = b.outTimeT || 0
                break
            default:
                return 0
        }

        if (sortOrder === 'asc') {
            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return aValue - bValue
            }
            return aValue > bValue ? 1 : aValue < bValue ? -1 : 0
        } else {
            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return bValue - aValue
            }
            return aValue < bValue ? 1 : aValue > bValue ? -1 : 0
        }
    })

    // Prepare data for export
    descArr = sortedData.map(s => {
        const phone = `${s.pref || ''}${s.did || ''}`
        return {
            phone: phone,
            forward: s.output?.output || s.redirect_output || '',
            note: s.notes || '',
            active: `${s.in || 0} - ${s.out || 0}`,
            date: `${s.inTimeT ? Utils.secToHours(s.inTimeT) : ''} - ${s.outTimeT ? Utils.secToHours(s.outTimeT) : ''}`,
            line: s.dlines || 0,
            no_line: s.nodline || 0
        }
    })

    // Paginate data
    const paginatedData = rowsPerPage > 0
        ? sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : sortedData

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10)
        setRowsPerPage(newRowsPerPage)
        setPage(0)
        Cookies.set("did", newRowsPerPage, { expires: 30 })
    }

    useEffect(() => {
        let cancelled = false
        Api.getShortDataINDID()
            .then((res) => {
                if (cancelled) return
                const data = res?.data || {}
                setShorts(Array.isArray(data.short) ? data.short : [])
                setEmployees(Array.isArray(data.sips) ? data.sips : [])
            })
            .catch((err) => {
                if (!cancelled) console.error('DidTable fetch error:', err)
            })
        return () => { cancelled = true }
    }, [])

    return (
        <div className="tableParent" id="tableParent">
            <Paper sx={{ p: 3, boxShadow: 3 }}>
                <Box sx={employeeTableStyles.headerBox}>
                    <Box sx={employeeTableStyles.headerTitleBox}>
                        <Typography sx={employeeTableStyles.title} variant="h5" component="h1">{title || menu.did[langIndex]}</Typography>
                    </Box>
                
                </Box>
                <Box sx={employeeTableStyles.searchSortContainer}>
                    <Box sx={employeeTableStyles.searchBox}>
                        <AssignedSearch
                            value={searchQuery}
                            onChange={handleSearchChange}
                            onAdd={onAdd}
                            placeholder={input.search?.[langIndex] || 'Search...'}
                            showAdd={true}
                            addColor={color}
                        />
                    </Box>
                    <Box sx={employeeTableStyles.sortContainer}>
                        <FormControl size="small" sx={employeeTableStyles.sortFormControl}>
                            <InputLabel>{input.sortBy[langIndex]}</InputLabel>
                            <Select
                                value={sortBy || ''}
                                label={input.sortBy[langIndex]}
                                onChange={(e) => {
                                    if (e.target.value) {
                                        handleSort(e.target.value)
                                    } else {
                                        setSortBy(null)
                                        setSortOrder(null)
                                    }
                                }}
                                sx={employeeTableStyles.sortSelect}
                            >
                                <MenuItem value="">
                                    <em>{input.none[langIndex]}</em>
                                </MenuItem>
                                <MenuItem value="phone">{sip.phone[langIndex]}</MenuItem>
                                <MenuItem value="forward">{sip.forward[langIndex]}</MenuItem>
                                <MenuItem value="notes">{input.name[langIndex]}</MenuItem>
                                <MenuItem value="active">{did.active[langIndex]}</MenuItem>
                                {/* <MenuItem value="inTimeT">In Time</MenuItem>
                                <MenuItem value="outTimeT">Out Time</MenuItem> */}
                            </Select>
                        </FormControl>
                        {sortBy && (
                            <IconButton
                                size="small"
                                onClick={() => handleSort(sortBy)}
                                sx={employeeTableStyles.getSortIconButton(color)}
                                aria-label={sortOrder === 'asc' ? input.sortDesc[langIndex] : input.sortAsc[langIndex]}
                            >
                                {sortOrder === 'asc' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                            </IconButton>
                        )}
                    </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <ToggleButtonGroup
                        value={providerFilter}
                        exclusive
                        onChange={handleProviderFilterChange}
                        size="medium"
                        sx={{
                            '& .MuiToggleButton-root': { textTransform: 'none', py: 1, px: 2, fontSize: '0.95rem' },
                            '& .MuiToggleButton-root.Mui-selected': { backgroundColor: color, color: '#fff', '&:hover': { backgroundColor: color } },
                        }}
                    >
                        <ToggleButton value="all" aria-label="all">
                            {did.all?.[langIndex] ?? 'All'}
                        </ToggleButton>
                        <ToggleButton
                            value="telegram"
                            aria-label="telegram"
                            sx={{
                                '&.Mui-selected': {
                                    backgroundColor: '#0088cc !important',
                                    color: '#fff !important',
                                    '&:hover': { backgroundColor: '#0077b5 !important' },
                                },
                            }}
                        >
                            <TelegramIcon sx={{ fontSize: 22, mr: 0.75 }} />
                            {telecomunication.telegram_title?.[langIndex] ?? 'Telegram'}
                        </ToggleButton>
                        <ToggleButton
                            value="whatsapp"
                            aria-label="whatsapp"
                            sx={{
                                '&.Mui-selected': {
                                    backgroundColor: '#25D366 !important',
                                    color: '#fff',
                                    '&:hover': { backgroundColor: '#1da851 !important' },
                                },
                            }}
                        >
                            <WhatsAppIcon sx={{ fontSize: 22, mr: 0.75 }} />
                            {telecomunication.whatsapp_title?.[langIndex] ?? 'WhatsApp'}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                {providerFilter === 'telegram' && (
                    <Alert
                        severity="info"
                        icon={<TelegramIcon sx={{ color: '#0088cc' }} />}
                        sx={{
                            mb: 2,
                            backgroundColor: 'rgba(0, 136, 204, 0.08)',
                            border: '1px solid rgba(0, 136, 204, 0.3)',
                            '& .MuiAlert-message': { width: '100%' },
                        }}
                    >
                        <Typography variant="body2" component="span">
                            {telecomunication.telegram_handle_calls?.[langIndex] ?? 'Connect Telegram to handle calls, and manage customer communication in real time.'}
                        </Typography>
                    </Alert>
                )}
                {providerFilter === 'whatsapp' && (
                    <Alert
                        severity="info"
                        icon={<WhatsAppIcon sx={{ color: '#25D366' }} />}
                        sx={{
                            mb: 2,
                            backgroundColor: 'rgba(37, 211, 102, 0.08)',
                            border: '1px solid rgba(37, 211, 102, 0.3)',
                            '& .MuiAlert-message': { width: '100%' },
                        }}
                    >
                        <Typography variant="body2" component="span">
                            {telecomunication.whatsapp_handle_calls?.[langIndex] ?? 'Connect WhatsApp to handle calls, and communicate with customers directly from the system.'}
                        </Typography>
                    </Alert>
                )}
                {loading ? (
                    <Box sx={employeeTableStyles.loadingBox}>
                        <CircularProgress sx={{ color }} />
                    </Box>
                ) : paginatedData.length ? (
                    <>
                        <Box sx={activitiesStyles.activitiesContainer}>
                            {paginatedData.map((item, index) => {
                                const phone = `${item.pref || ''}${item.did || ''}`
                                const isActive = item.redirect?.st === 10 || (!item.redirect?.st && item.ord > 0)
                                const displayName = item.notes || phone

                                return (
                                    <Card key={`${item.pref}-${item.did}-${item.profile || ''}-${index}`} sx={{ ...activitiesStyles.activityCard, '&:hover': { boxShadow: `0 8px 24px ${color}26`, borderColor: color } }}>
                                        <CardContent sx={activitiesStyles.cardContent}>
                                            <Box sx={activitiesStyles.cardContentBox}>

                                                {item.provider === 3 || item.provider === 4 ? (
                                                    <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, borderRadius: '50%', backgroundColor: '#0088cc', color: '#fff' }}>
                                                        <TelegramIcon sx={{ fontSize: 28 }} />
                                                    </Box>
                                                ) : item.provider === 7 ? (
                                                    <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, borderRadius: '50%', backgroundColor: '#25D366', color: '#fff' }}>
                                                        <WhatsAppIcon sx={{ fontSize: 28 }} />
                                                    </Box>
                                                ) : (
                                                    <Avatar sx={{
                                                        ...activitiesStyles.getActivityAvatar(isActive),
                                                        ...(isActive && { bgcolor: color, boxShadow: `0 4px 12px ${color}4D` }),
                                                    }}>
                                                        {displayName?.[0]?.toUpperCase() || 'D'}
                                                    </Avatar>
                                                )}

                                                <Box sx={activitiesStyles.activityContentBox}>
                                                    <Typography variant="h6" sx={activitiesStyles.activityTitle}>
                                                        {displayName}
                                                    </Typography>

                                                    <Box sx={activitiesStyles.metadataBox}>
                                                        <Box sx={activitiesStyles.metadataItem}>
                                                            <PhoneIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                            <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                <strong>{sip.phone[langIndex]}:</strong> {phone}
                                                            </Typography>
                                                        </Box>
                                                        {(item.output?.output || item.redirect_output) ? (() => {
                                                            const forwardVal = item.output?.output || item.redirect_output || '-'
                                                            const inSips = employees.find(e => String(e.buddy) === String(forwardVal))
                                                            const inShorts = shorts.find(s => String(s.virtual) === String(forwardVal))
                                                            const tooltipTitle = inSips
                                                                ? employee.employee_label[langIndex]
                                                                : inShorts && inShorts.isivr === 1
                                                                    ? short.ivr_lists[langIndex]
                                                                    : inShorts && inShorts.isivr === 0
                                                                        ? short.group[langIndex]
                                                                        : (shortFunctionList[String(forwardVal)]?.[langIndex] ?? forwardVal)
  return (
                                                                <Box sx={activitiesStyles.metadataItem}>
                                                                    <Tooltip title={tooltipTitle}>
                                                                        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
                                                                            {inSips ? (
                                                                                <PersonIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                            ) : inShorts && inShorts.isivr === 0 ? (
                                                                                <GroupIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                            ) : inShorts && inShorts.isivr === 1 ? (
                                                                                <Box component="span" sx={{ ...activitiesStyles.iconSquareBox, mr: 0.5 }}>
                                                                                    <GraphicEqIcon fontSize="small" sx={{ color, fontSize: '18px' }} />
                                                                                </Box>
                                                                            ) : forwardVal === "10999" ? (
                                                                                <ManageAccountsIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                            ) : forwardVal === "10888" ? (
                                                                                <CallEndIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                            ) : forwardVal === "59999" || forwardVal === "100097" ? (
                                                                                <VoicemailIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                            ) : null}

                                                                            <Typography component="span" variant="caption" sx={activitiesStyles.metadataText}>
                                                                                <strong>{sip.forward[langIndex]}:</strong> {(shortFunctionList[String(forwardVal)]?.[langIndex] ?? forwardVal)}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Tooltip>
                                                                </Box>
                                                            )
                                                        })() : null}

                                                        {(item.inTimeT || item.outTimeT) ? (
                                                            <>
                                                                <Box sx={activitiesStyles.metadataItem}>
                                                                    <AccessTimeIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                    <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                        <strong>{did.date[langIndex]}:</strong> {item.inTimeT ? Utils.secToHours(item.inTimeT) : ''} - {item.outTimeT ? Utils.secToHours(item.outTimeT) : ''}
                                                                    </Typography>
                                                                </Box>

                                                            </>
                                                        ) : null}
                                                        {item.dlines !== undefined ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <AltRouteIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{did.line[langIndex]}:</strong> {item.dlines || 0}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        {item.nodline ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <PhoneDisabledIcon fontSize="small" sx={{ ...activitiesStyles.metadataIcon, mr: 0.5, color: '#ce405f ' }} />
                                                                <Typography variant="caption" sx={{ ...activitiesStyles.metadataText, color: '#ce405f' }}>
                                                                    <strong>{did.noLine[langIndex]}:</strong> {item.nodline}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        {item.update_date ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <CalendarMonthIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{did.updateDate[langIndex]}:</strong> {moment.utc(item.update_date).format('DD-MM-YYYY HH:mm:ss')}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        {item.date || item.update_date ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <HistoryIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{did.set_line[langIndex]}:</strong> {item.update_date?moment(item.update_date).format('DD-MM-YYYY HH:mm:ss') :moment(item.date).format('DD-MM-YYYY HH:mm:ss') }
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                    </Box>
                                                </Box>

                                                <Box sx={{...employeeTableStyles.actionsContainer, minHeight: '130px'}}>

                                                    <Box sx={employeeTableStyles.actionButtonsBox}>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => onEdit(item)}
                                                            sx={{
                                                                color,
                                                                '&:hover': { backgroundColor: `${color}15`, transform: 'scale(1.1)' },
                                                                transition: 'all 0.2s ease',
                                                                padding: '6px',
                                                            }}
                                                            aria-label="Edit"
                                                        >
                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                        </IconButton>
                                                        {employeeData?.buddy ? null : (
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => onDelete(item)}
                                                            sx={{
                                                                ...employeeTableStyles.deleteIconButton,
                                                                ...(profileEmpty && {
                                                                    opacity: 0.45,
                                                                    cursor: 'not-allowed',
                                                                    '&:hover': { backgroundColor: 'transparent', transform: 'none' },
                                                                }),
                                                            }}
                                                            aria-label="Delete"
                                                        >
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                        </IconButton>
                                                        )}
                                                    </Box>
                                                    {isActive && (
                                                        <CheckCircleIcon sx={employeeTableStyles.activeIcon(color)} />
                                                    )}
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                )
                            })}
                        </Box>
                        <Box sx={employeeTableStyles.footerBox}>
                            <Box className="footer-chip-box" sx={{
                                ...employeeTableStyles.footerLinksBox,
                                '& .MuiChip-root': { borderColor: color },
                                '& .MuiChip-root:hover': { backgroundColor: `${color} !important`, color: '#fff !important', borderColor: `${color} !important` },
                                '& .MuiChip-root:hover .MuiChip-label': { color: '#fff !important' },
                            }}>
                                <Chip label="EXCEL" variant="outlined" size="small" onClick={() => Utils.dataToExel(titleArr, descArr)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                                <Chip label="CSV" variant="outlined" size="small" onClick={() => Utils.dataToExel(titleArr, descArr)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                                <Chip label="PRINT" variant="outlined" size="small" onClick={() => window.print()} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                                <Chip label="COPY" variant="outlined" size="small" onClick={() => Utils.copy(setCopied)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                            </Box>
                            <TablePagination
                                rowsPerPageOptions={[10, 18, 27, 36, { label: did.all[langIndex], value: -1 }]}
                                component="div"
                                count={sortedData.length}
                                labelRowsPerPage={input.rowsPerPage[langIndex]}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Box>
                    </>
                ) : (
                    <Box sx={employeeTableStyles.emptyStateBox}>
                        <Typography variant="body1" color="text.secondary">
                           {did.no_found[langIndex]}
                        </Typography>
                    </Box>
                )}
            </Paper>
            {copied ? <div className="copied">Copied</div> : null}
            <Modal
                aria-labelledby="manager-required-modal-title"
                open={managerModalOpen}
                onClose={() => setManagerModalOpen(false)}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{ backdrop: { timeout: 500 } }}
            >
                <Fade in={managerModalOpen}>
                    <Box sx={{ ...style, position: 'relative', borderRadius: '12px', overflow: 'visible', maxWidth: 480 }}>
                        <IconButton
                            onClick={() => setManagerModalOpen(false)}
                            aria-label="Close"
                            sx={{
                                position: 'absolute',
                                right: -56,
                                top: 24,
                                zIndex: 1,
                                width: 56,
                                height: 40,
                                borderRadius: '0 12px 12px 0',
                                backgroundColor: '#ce405f',
                                color: '#fff',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                '&:hover': { backgroundColor: '#b83854', color: '#fff' },
                            }}
                        >
                            <CloseIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                        <Typography id="manager-required-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                            {langIndex === 2 ? 'Информация' : langIndex === 3 ? 'Տեղեկություն' : 'Information'}
                        </Typography>
                        <hr />
                        <Alert
                            severity="error"
                            sx={{
                                backgroundColor: 'rgba(206, 64, 95, 0.08)',
                                border: '1px solid rgba(206, 64, 95, 0.35)',
                                '& .MuiAlert-message': { width: '100%' },
                            }}
                        >
                            <Typography variant="body2" component="span">
                                {did.contact_manager_changes[langIndex]}
                            </Typography>
                        </Alert>
                    </Box>
                </Fade>
            </Modal>
        </div>
    )
}
